import apiClient from "@/services/apiClient";


const client = apiClient;

const getEnrolments = async (endpoint) => {
  const response = await client.get(`/AdminEnrolment/${endpoint}`);
  return response.data;
};

export const adminEnrolmentService = {
  getAllEnrolments: () => getEnrolments("All"),
  getPendingEnrolments: () => getEnrolments("Pending"),
  getSubmittedEnrolments: () => getEnrolments("Submitted"),
  getReturnedEnrolments: () => getEnrolments("Returned"),
  getApprovedEnrolments: () => getEnrolments("Approved"),
  getRejectedEnrolments: () => getEnrolments("Rejected"),
  getEnrolmentsByStatus: (status) => getEnrolments(`Status/${status}`),
  getWorkflowHistory: async (studentEnrollmentId) => {
    const response = await client.get(`/AdminEnrolment/GetWorkflowHistory/${studentEnrollmentId}`);
    return response.data;
  },
  getEnrolmentDetail: async (studentBookingId) => {
    const response = await client.get("/AdminEnrolment/Enrollment", { params: { pStudentBookingId: studentBookingId } });
    return response.data;
  },
  viewDocument: (studentEnrollmentId, studentDocId) => client.get(
    `/AdminEnrolment/${studentEnrollmentId}/documents/${studentDocId}/view`,
    { responseType: "blob" },
  ),
  downloadDocument: (studentEnrollmentId, studentDocId) => client.get(
    `/AdminEnrolment/${studentEnrollmentId}/documents/${studentDocId}/download`,
    { responseType: "blob" },
  ),
  performEnrolmentAction: (payload) => client.post("/AdminEnrolment/Action", payload),
  updateStatementOfAttainmentNumber: async (studentEnrollmentId, statementOfAttainmentNumber) => {
    const response = await client.put(
      `/AdminEnrolment/${studentEnrollmentId}/statement-of-attainment`,
      { statementOfAttainmentNumber },
    );
    return response.data;
  },
  exportCsvAsqa: async (payload = {}) => {
    const response = await client.post("/AdminEnrolment/exportcsv", payload, {
      responseType: "blob",
    });

    return response;
  },
};
